import { render, staticRenderFns } from "./BotMarkets.vue?vue&type=template&id=1d7d44c5&"
import script from "./BotMarkets.vue?vue&type=script&lang=js&"
export * from "./BotMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports